<template>
  <div>
    <input
      id="__ncm_input_telefone"
      type="text"
      class="form-control"
      :placeholder="placeholder"
      :disabled="disabled"
      @keydown.enter="onEnter"
      @keydown="onKeyDown"
      @keyup="onKeyUp"
      :value="currentValue"
    />
    <span v-bind:class="icon"></span>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'input-telefone',
  props: ['value', 'placeholder', 'icon', 'disabled'],
  data() {
    return {
      currentValue: ''
    }
  },
  mounted() {},
  methods: {
    mask(value) {
      this.currentValue = value.replace(/[^0-9]+/g, '')
      if (this.currentValue.length > 2) {
        this.currentValue = `(${this.currentValue.substring(0, 2)}) ${this.currentValue.substring(
          2
        )}`
      }
      if (this.currentValue.length > 9) {
        this.currentValue = `${this.currentValue.substring(0, 9)}-${this.currentValue.substring(9)}`
      }
      if (this.currentValue.length === 15) {
        this.currentValue = value.replace(/[^0-9]+/g, '')
        const ddd = this.currentValue.substring(0, 2)
        const prefixo = this.currentValue.substring(2, 7)
        const sufixo = this.currentValue.substring(7)
        this.currentValue = `(${ddd}) ${prefixo}-${sufixo}`
      }
      this.$emit('input', this.valueUnmasked)
    },

    onKeyUp(event) {
      this.mask(event.target.value)
    },

    onKeyDown(e) {
      if (e.target.value.length === 15) {
        if (e.keyCode !== 8 && e.keyCode !== 9) {
          e.preventDefault()
        }
      }
    },

    onEnter() {
      this.$emit('on-enter')
    }
  },
  computed: {
    valueUnmasked() {
      return this.currentValue.replace(/[^0-9]+/g, '')
    }
  },
  watch: {
    value(vl) {
      if (vl) {
        this.currentValue = vl
        this.mask(vl)
      }
    }
  }
}
</script>
